import {
    Component,
    type OnInit,
    inject,
    ChangeDetectionStrategy,
} from "@angular/core";
import { DATA_QAA, dataQaaPrefix } from "@firm360/libs/observability/data-qaa";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
    type HotkeyGroup,
    HotkeysService,
    HotkeysShortcutPipe,
} from "@ngneat/hotkeys";

@Component({
    selector: "app-hotkey-help-modal",
    hostDirectives: [DATA_QAA],
    templateUrl: "./hotkey-help-modal.component.html",
    styleUrls: ["./hotkey-help-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HotkeysShortcutPipe],
})
export class HotkeyHelpModalComponent implements OnInit {
    protected readonly qaaPrefix = dataQaaPrefix(HotkeyHelpModalComponent);

    activeModal = inject(NgbActiveModal);
    private hotkeyService = inject(HotkeysService);

    static readonly casuallyDismissible = true;
    groups: HotkeyGroup[];

    ngOnInit(): void {
        this.groups = this.hotkeyService.getShortcuts();
    }
}
